import clsx from 'clsx';
import { InfoItem } from 'components/molecules/InfoItem/InfoItem';
import { CompanyPageCompanyFragment } from 'generated/graphql';
import { useState } from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';
import {
  AI_INTERVIEW_INTEGRITY_MONITORING_LABEL,
  ASSESSMENT_INTEGRITY_MONITORING_LABEL,
  INTEGRITY_MONITORING_AVAILABLE_LABEL,
} from './IntegrityMonitoringSection.constants';
import IntegrityMonitoringSectionForm from './IntegrityMonitoringSectionForm';
import styles from './IntegrityMonitoringSection.module.scss';

type IntegrityMonitoringSectionProps = {
  company: CompanyPageCompanyFragment;
};

const IntegrityMonitoringSection = ({
  company,
}: IntegrityMonitoringSectionProps) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
  };

  const handleSave = () => {
    setIsEditing(false);
  };

  return isEditing ? (
    <IntegrityMonitoringSectionForm
      company={company}
      onCancelClick={handleCancelClick}
      onSave={handleSave}
    />
  ) : (
    <IntegrityMonitoringSectionView
      company={company}
      onEditClick={handleEditClick}
    />
  );
};

const IntegrityMonitoringSectionView = ({
  company,
  onEditClick,
}: {
  company: CompanyPageCompanyFragment;
  onEditClick: () => void;
}) => (
  <div className={styles.viewContainer}>
    <div className={styles.header}>
      <h3 className={styles.title}>Integrity monitoring</h3>
      <Button variant="secondary" size="medium" onClick={onEditClick}>
        Edit
      </Button>
    </div>
    <div className={styles.content}>
      <InfoItem
        label={INTEGRITY_MONITORING_AVAILABLE_LABEL}
        value={company.isIntegrityMonitoringAvailable ? 'Enabled' : 'Disabled'}
      />
      <div
        className={clsx(
          styles.nestedFields,
          !company.isIntegrityMonitoringAvailable && styles.nestedFieldsDisabled
        )}
      >
        <InfoItem
          label={ASSESSMENT_INTEGRITY_MONITORING_LABEL}
          value={
            company.isIntegrityMonitoringAssessmentDefaultEnabled
              ? 'Enabled'
              : 'Disabled'
          }
        />
        <InfoItem
          label={AI_INTERVIEW_INTEGRITY_MONITORING_LABEL}
          value={
            company.isIntegrityMonitoringAiInterviewDefaultEnabled
              ? 'Enabled'
              : 'Disabled'
          }
        />
      </div>
    </div>
  </div>
);

export default IntegrityMonitoringSection;
